$(function () {
	// custom js/jquery
	$('input[name="range"]').daterangepicker({
		autoUpdateInput: false,
		showWeekNumbers: true,
		"cancelClass": "btn-outline-primary",
		locale: {
			"format": "DD.MM.YYYY",
			"separator": " - ",
			"applyLabel": "auswählen",
			"cancelLabel": "abbrechen",
			"fromLabel": "von",
			"toLabel": "bis",
			"customRangeLabel": "Custom",
			"weekLabel": "KW",
			"daysOfWeek": [
				"So",
				"Mo",
				"Di",
				"Mi",
				"Do",
				"Fr",
				"Sa"
			],
			"monthNames": [
				"Januar",
				"Februar",
				"März",
				"April",
				"Mai",
				"Juni",
				"Juli",
				"August",
				"September",
				"Oktober",
				"November",
				"Dezember"
			],
			"firstDay": 1
		}
	});

	$('input[name="range"]').on('apply.daterangepicker', function (ev, picker) {
		$(this).val(picker.startDate.format('DD.MM.YYYY') + ' - ' + picker.endDate.format('DD.MM.YYYY'));
	});

	$('input[name="range"]').on('cancel.daterangepicker', function (ev, picker) {
		$(this).val('');
	});

	$('input[name="duration"]').daterangepicker({
		autoUpdateInput: false,
		showWeekNumbers: true,
		"opens": "center",
		"drops": "up",
		"singleDatePicker": false,
		"timePicker": true,
		"timePicker24Hour": true,
		"cancelClass": "btn-outline-primary",
		locale: {
			"format": "DD.MM.YYYY HH:mm",
			"separator": " - ",
			"applyLabel": "auswählen",
			"cancelLabel": "abbrechen",
			"fromLabel": "von",
			"toLabel": "bis",
			"customRangeLabel": "Custom",
			"weekLabel": "KW",
			"daysOfWeek": [
				"So",
				"Mo",
				"Di",
				"Mi",
				"Do",
				"Fr",
				"Sa"
			],
			"monthNames": [
				"Januar",
				"Februar",
				"März",
				"April",
				"Mai",
				"Juni",
				"Juli",
				"August",
				"September",
				"Oktober",
				"November",
				"Dezember"
			],
			"firstDay": 1
		}
	});

	$('input[name="duration"]').on('apply.daterangepicker', function (ev, picker) {
		$(this).val(picker.startDate.format('DD.MM.YYYY HH:mm') + ' - ' + picker.endDate.format('DD.MM.YYYY HH:mm'));
	});

	$('input[name="duration"]').on('cancel.daterangepicker', function (ev, picker) {
		$(this).val('');
	});

	var qrcanvasEl = document.getElementById("qr-canvas");
	var qrcode = new QRCode(qrcanvasEl, {
		text: 'https://app.registroapp.de/?client=' + qrcanvasEl.dataset.hash,
		width: 1000,
		height: 1000,
	});

	var qrsvgEl = document.getElementById("qr-svg");
	var qrcode_svg = new QRCode(qrsvgEl, {
		text: 'https://app.registroapp.de/?client=' + qrsvgEl.dataset.hash,
		width: 1000,
		height: 1000,
		useSVG: true
	});

	var pngTimer = setInterval(() => {
		// console.log('check png');
		var qrpng = $('#qr-canvas img').attr('src');
		if (qrpng != '') {
			$('#dl-qr-png').attr('href', qrpng);
			// console.log("png href set");
			$('#dl-qr-png').removeClass("disabled");
			clearInterval(pngTimer);
		}
	}, 500);

	var svgTimer = setInterval(() => {
		// console.log('check svg');
		$('#qr-svg svg').attr({ version: '1.1', xmlns: "http://www.w3.org/2000/svg" });
		var svg = $('#qr-svg svg').attr('id', 'qr-svg-svg');
		// var svg = $('#qr-svg svg').html();
		// var b64 = btoa(svg);
		// console.log($('#dl-qr-svg').attr('href').length > 50);
		downloadSVG(document.getElementById("qr-svg-svg"));

		if ($('#dl-qr-svg').attr('href') && $('#dl-qr-svg').attr('href').length > 50) {
			// console.log("svg href set");
			// console.log($('#dl-qr-svg').attr('href').length);
			$('#dl-qr-svg').removeClass("disabled");
			clearInterval(svgTimer);
		}
	}, 500);


	function downloadSVG(svg) {
		const svgClone = svg.cloneNode(true)
		document.body.appendChild(svgClone)
		// synchronizeCssStyles(svg, svgClone, true)

		var data = new XMLSerializer().serializeToString(svgClone);
		var uri = 'data:application/octet-stream; base64,' + btoa(data);

		// console.log(uri)
		$('#dl-qr-svg').attr('href', uri);
		// downloadUri(uri, (svg.id || 'original-filename') + '.svg')

		svgClone.remove()
	}


});

// oui
console.log("%c oui. code " + "%c https://oui-studios.de ", "background: #324047; color: #fff;", "background: transparent; color: #324047");
